import { EBrokerFeature } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { getSteps } from "scenes/Properties/scenes/Applications/PropertyDetailApplications.util";
import {
  getSchema as getSchema1,
  uiSchema as uiSchema1,
} from "./schema.duplicateApplication.1";
import { EField, IExtraData } from "./schema.duplicateApplication.types";

// eslint-disable-next-line import/no-default-export
export default (extraData: IExtraData) => {
  const { broker } = extraData;

  const intakeType = broker?.intakeType || 2;
  // Derive the broker feature flags straight from the broker so the "Invited"
  // step is filtered out for non-RentMatch / non-calendar-sync (MHP) brokers,
  // regardless of which screen (RentMatch row, legacy list, bulk) opens the
  // duplicate modal.
  const hasCalendarSync =
    broker?.features?.includes(EBrokerFeature.CalendarSync) ?? false;
  const hasRentMatch =
    broker?.features?.includes(EBrokerFeature.RentMatch) ?? false;
  const steps = getSteps(intakeType, hasCalendarSync, hasRentMatch);

  const defaultValues = {
    [EField.Step]: steps[0],
  };

  return [
    {
      schema: getSchema1(defaultValues, extraData, steps),
      uiSchema: uiSchema1(extraData),
    },
  ];
};
